import { type HTMLAttributes, forwardRef } from 'react'
import { labelBadgeVariants, LabelBadgeTextVariants } from './LabelBadge.variants'

export interface LabelBadgeProps extends HTMLAttributes<HTMLDivElement> {
  label: string
  active?: boolean
  accentColor?: 'none' | 'yellow' | 'green' | 'blue'
}

export const LabelBadge = forwardRef<HTMLDivElement, LabelBadgeProps>(
  ({ label, active = false, accentColor = 'yellow', className, ...props }, ref) => {
    return (
      <div className={labelBadgeVariants({ active, accentColor, className })} ref={ref} {...props}>
        <span className={LabelBadgeTextVariants({ active, accentColor, className })}>{label}</span>
      </div>
    )
  }
)

LabelBadge.displayName = 'LabelBadge'
